module.exports = __webpack_public_path__ + "images/icons/flags/AT-3cf1450c.svg";